exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-dev-tip {\n  padding:5px 10px;\n  background-color: #FFCC00;\n  color:#000;\n  margin-bottom:0.3em;\n  font-size:12px;\n}\n", ""]);

// exports
